export default class NiceSelect {
    private static initialized = false;

    static init(): void {
        if (this.initialized) {
            return;
        }

        this.initializeSelects();
        this.initialized = true;
    }

    private static initializeSelects(): void {
        const selectElements = document.querySelectorAll<HTMLSelectElement>('.form-select');

        if (selectElements.length > 0) {
            selectElements.forEach((select) => {
                this.bindToSelect(select);
            });
        }
    }

    private static bindToSelect(select: HTMLSelectElement): void {
        try {
            // Check if NiceSelect library is available
            if (typeof window.NiceSelect !== 'undefined') {
                window.NiceSelect.bind(select);
            } else {
                console.warn('NiceSelect library not found');
            }
        } catch (error) {
            console.warn('Failed to bind NiceSelect to element:', error);
        }
    }


    static reinitialize(): void {
        this.initialized = false;
        this.init();
    }

    static bindElement(select: HTMLSelectElement): void {
        this.bindToSelect(select);
    }
}

// Extend the global Window interface to include NiceSelect
declare global {
    interface Window {
        NiceSelect?: {
            bind(element: HTMLSelectElement): void;
        };
    }
}
